import classnames from 'classnames'
import Textfield from '@components/Textfield'
import Button from '@components/Button'
import Icon from '@components/Icon'
import ErrorMessage from '@components/ErrorMessage'

import purchaseStyles from 'subscription-flow/styles.module.scss'

const PromoPrice = ({
    hasPromoPrice,
    applyPromoCode,
    onPromoCodeChange,
    promoCode,
    resetSelectedRate,
    selectedRate,
    products,
}) => {
    const invalidCode = hasPromoPrice instanceof Error
    ///we have to check selected product has a promocode property
    const isPromoCodeProduct = () => {
        const hasPromocodeProduct = products.filter(product => product.ratePlans[0].promoCode)
        const checkSelectedProduct = hasPromocodeProduct.find(
            product => product.ratePlans[0].ratePlanId === selectedRate.rateId
        )
        return checkSelectedProduct
    }
    return (
        <>
            {hasPromoPrice === true && promoCode ? (
                <div className="d-flex align-items-center text-">
                    <span className="text-light mr-1">
                        <T>subscription.purchase.promo.code</T>
                    </span>
                    <span className="font-weight-bold">{promoCode}</span>
                    <span
                        className="ml-2"
                        onClick={() => {
                            onPromoCodeChange('')
                            applyPromoCode(true)
                            isPromoCodeProduct && resetSelectedRate(null)
                        }}>
                        <Icon type="close" size="xxs" />
                    </span>
                </div>
            ) : (
                <div className="col-sm-6 mb-6 px-0">
                    <div className=" d-sm-flex">
                        <Textfield
                            value={promoCode}
                            onChange={e => onPromoCodeChange(e.target.value)}
                            name="specialRates"
                            type="input"
                            className={purchaseStyles.promoTextfield}
                            label={<T>subscription.purchase.unlock.rates</T>}
                        />
                        <Button
                            btnStyle="primary"
                            className={classnames('ml-2', 'px-4', purchaseStyles.applyBtn)}
                            onClick={() => applyPromoCode()}
                            disabled={hasPromoPrice && promoCode === ''}>
                            <T>subscription.purchase.label.apply</T>
                        </Button>
                    </div>
                    {invalidCode && (
                        <ErrorMessage messages={[<T key="1">subscription.purchase.promo.code.error</T>]} type="text" />
                    )}
                </div>
            )}
        </>
    )
}

export default PromoPrice
